import { render, staticRenderFns } from "./partners-link.vue?vue&type=template&id=56d9c2de&"
import script from "./partners-link.vue?vue&type=script&lang=js&"
export * from "./partners-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d9c2de')) {
      api.createRecord('56d9c2de', component.options)
    } else {
      api.reload('56d9c2de', component.options)
    }
    module.hot.accept("./partners-link.vue?vue&type=template&id=56d9c2de&", function () {
      api.rerender('56d9c2de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/base/vacancies/partners-link.vue"
export default component.exports